









































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IDialogOption } from '@/models/dialog';

@Component({
    props: ['options'],
})
export default class AppDialogComponent extends Vue {
    public options: IDialogOption;
    public onClose(): void {
        if (this.options && this.options.model) {
            this.options.model = false;
            if (this.options.onClose && typeof(this.options.onClose) === 'function') {
                this.options.onClose();
            }
        }
    }
    public onAction(): void {
        if (this.options && this.options.onAction) {
            if (this.options.onAction && typeof (this.options.onAction) === 'function') {
                this.options.onAction();
            }
        }
    }
}

